<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #status="{text}">
      {{ text.status - 0 ? '启用' : '禁用' }}
    </template>
    <template #name="{text}">
      <a-button type="link" @click="() => deal({ ...text })">{{
        text.name
      }}</a-button>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: '公共内容',
        resizable: true,
        width: 100,
        align: 'center',
        slots: { customRender: 'name' }
      },
      {
        title: '状态',
        width: 150,
        resizable: true,
        align: 'center',
        slots: { customRender: 'status' }
      },
      {
        title: '当前内容',
        dataIndex: 'content',
        key: 'content',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '最近更新人',
        dataIndex: 'modifier',
        key: 'modifier',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '最近更新时间',
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        resizable: true,
        align: 'center',
        width: 120
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
